import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';

const RatingsAndReviewsZone = ({ selectedProducts = [], getText = () => {} }) => {
    const renderContent = () => {
        return (
            <Text
                fontSize='sm'
                color='gray'
            >
                Ratings & Reviews Zone
            </Text>
        );
    };

    return (
        <CompareZoneBase
            selectedProducts={selectedProducts}
            getText={getText}
            titleKey='ratingsAndReviews'
            renderContent={renderContent}
        />
    );
};

RatingsAndReviewsZone.propTypes = {
    selectedProducts: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func
};

export default wrapFunctionalComponent(RatingsAndReviewsZone, 'RatingsAndReviewsZone');
